export const permissionsKeys = {
  page: 'content-management.regulations',
  pageBlockFind: 'content-management.regulations.find',
  pageBlockCreate: 'content-management.regulations.create',
  pageBlockUpdate: 'content-management.regulations.update',
  pageBlockRemove: 'content-management.regulations.remove',
  pageBlockUpdatePublish: 'content-management.publish.regulations.update',
  pageBlockUpdateStatusToDraft: 'content-management.regulations.updateStatusToDraft',
  pageBlockUpdateInactivate: 'content-management.inactivate.regulations.update',
} as const;
